import { differenceInDays, format } from "date-fns";
import { useMemo, useState } from "react";
import { useQuery } from "react-query";

import { normalizeVehicleAnalytics } from "~/entity/Ivideon/lib/normalizeAnalytics";
import { IvideonAnalyticsIProps } from "~/entity/Ivideon/model/schema";
import { ParseForServerResultIProps } from "~/widgets/Filters/FilterSummary/schema/types";

import { useIvideon } from "./useIvideon";

export const useGetVehicleAnalytics2 = () => {
  const [params, setParams] = useState<IvideonAnalyticsIProps | null>(null);
  const [dates, setDates] = useState<{ startDate: Date; endDate: Date } | null>(
    null,
  );
  const { ivideonVehicleAnalytics } = useIvideon();

  const setParamsFilter = (props: ParseForServerResultIProps) => {
    const difference = differenceInDays(
      new Date(props.endDate),
      new Date(props.startDate),
    );

    const formatProps: IvideonAnalyticsIProps = {
      ...props,
      groupBy: difference > 0 ? "day" : "hour",
      startDate: format(props.startDate, "yyyy-MM-dd"),
      endDate: format(props.endDate, "yyyy-MM-dd"),
    };
    setParams(formatProps);
    setDates({
      startDate: props.startDate,
      endDate: props.endDate,
    });
  };

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["vehicle-analytics", params],
    queryFn: () => ivideonVehicleAnalytics(params!),
    refetchOnWindowFocus: false,
    enabled: !!params,
  });

  const normalizedData = useMemo(
    () => (data ? normalizeVehicleAnalytics(data.data) : undefined),
    [data],
  );

  return {
    data: normalizedData,
    isLoading,
    isError,
    setParamsFilter,
    dates,
    refetch,
  };
};
